import Model, { encoders, ID, Integer, JsonObject, MODEL_LEVEL } from 'src/models/model'
import BookingWeek from 'src/models/schedule/BookingWeek'
import BookingWeekMovie from 'src/models/schedule/BookingWeekMovie'
import PriceCard from 'src/models/showing/PriceCard'
import ShowingBadge from 'src/models/showing/ShowingBadge'

export default class PlanElement extends Model {
  static name = 'PlanElement'

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.FilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      color: {
        type: String
      },
      isTemplate: {
        type: Boolean,
        output: true,
        default: true
      },
      parentPlanElement: {
        type: PlanElement,
        encode: encoders.hasOne,
        reference: true
      },
      isCustom: {
        type: Boolean,
        output: true,
        default: false
      },
      default: {
        type: Boolean,
        default: false
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      titleCount: {
        type: Integer,
        default: 1
      },
      customSiteSchedule: {
        type: JsonObject,
        mergeDefault: true,
        default: () => ({})
      },
      config: {
        type: JsonObject,
        mergeDefault: true,
        default: () => ({
          customSiteSchedule: false,
          manualLayout: false,
          allowSimultaneousScreenings: false,
          screenTitleOneTwice: false,
          splitScreens: {}
        })
      },
      bookingWeek: {
        type: BookingWeek,
        reference: true,
        output: true
      },
      bookingWeekMovies: {
        type: [BookingWeekMovie],
        reference: true,
        allowDestroy: true,
        default: () => ([])
      },
      overridePriceCard: {
        type: Boolean,
        default: false
      },
      customPriceCard: {
        type: PriceCard,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      showingBadges: {
        type: [ShowingBadge],
        default: () => ([]),
        encode (data) {
          data.showingBadgeIds = _.map(this.showingBadges.data, 'id')
        },
        reference: true
      }
    }

    this.watchers = [
      [
        function () { return this.titleCount },
        function () { this.validateBookingWeekMovies() }
      ]
    ]

    this.queries.defaultPlanElements = {
      results: {
        planElements: [PlanElement]
      }
    }
  }

  initialize () {
    this.validateBookingWeekMovies()
  }

  validateBookingWeekMovies () {
    if (this.bookingWeekMovies && this.bookingWeekMovies.data.length < this.titleCount) {
      while (this.bookingWeekMovies.data.length < this.titleCount) {
        // console.log('VALIDATE BOOKING WEEK, ADDING BookingWeekMovie ' + this.name + ' ' + this.bookingWeekMovies.data.length)
        this.bookingWeekMovies.add(new BookingWeekMovie({
          priorityOrder: this.bookingWeekMovies.data.length,
          planElement: this,
          movie: {}
        }))
      }
    }

    if (this.bookingWeekMovies && this.bookingWeekMovies.data.length > this.titleCount) {
      while (this.bookingWeekMovies.data.length > this.titleCount) {
        // console.log('VALIDATE BOOKING WEEK, REMOVE BookingWeekMovie ' + this.name + ' ' + this.bookingWeekMovies.data.length)
        const bookingWeekToRemove = this.bookingWeekMovies.last
        if (bookingWeekToRemove.movie && bookingWeekToRemove.movie.isRemote) {
          this.titleCount = this.titleCount + 1
        } else {
          bookingWeekToRemove.remove()
        }
      }
    }
  }

  get numbers () {
    const numbers = []
    for (let i = 1; i < this.titleCount + 1; i++) {
      numbers.push(i)
    }
    return numbers
  }
}
